/**
 * 中转、批量中转
 */

export default {
  // 终端代理里批量中转的分摊方式给默认为手工填写每一票
  transfer_set_hand_fill_default: ['82931', '83141'], // 202509021038153708569
  // 中转【回扣】改成【佣金】
  transfer_set_kickback: ['77193'], // 202509021038153708569
  // 终端代理界面，中转费与中转回扣清除联动关系
  transfer_clear_linkage: ['99051', '70300'], // 202510201743266374430
  // 本地代理界面，中转费与中转回扣清除联动关系
  transfer_clear_linkage_local: ['70300'], // 202511291000595305512
  // 显示按重量分摊
  show_by_weight_ft: ['80790', '82220', '90080'], // 202510161434592601389
  // 定制企业顶部展示操作按钮
  show_operation_buttons_top: ['83224'], // 202511060938551475676
  // 终端代理必须上传图片
  terminal_agent_must_upload_pic: ['84820'] // 202511261553166632473
}
